import React from "react";
import Jobcatogaries from "../Home/jobCatogaries";
import StockList from "./StockGrid/StockGrid";
import HowItWorks from "./HowItWorks";
import Cta from "./Cta";
import Testimonal from "./Testimonal";
import Blog from "../Home/Blog";
import Client from "./Client";
import MapboxMap from "./MapboxMap";
import MapCon from "./MapCon";
import Banner from "./Banner";
import Offer from "./Offer";
import RegisterNow from "./RegisterNow";
import Subscribe from "./Subscribe";
import ResponsiveCarousel from './ResponsiveCarousel';
const Home = () => {
  return (
    <React.Fragment>
      <Banner />
      <ResponsiveCarousel />
      <Offer />
      <StockList />
      {/* <RegisterNow /> */}
      <MapCon />
      <Subscribe />
      {/* <Blog /> */}
    </React.Fragment>
  );
};

export default Home;
